<div fxFlex="100" fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20" class="mt-2">
    <button class="mb-1" routerLink="/industriepartner" mat-raised-button color="primary">
        Alle Industriepartner
    </button>
    <mat-card>
        <mat-card-header>
            <mat-card-title>
                Neuer Industriepartner
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <mat-form-field style="width: 350px;">
                <input type="text"
                placeholder="Industriepartner Stamm"
                [(ngModel)]="search"
                (ngModelChange)="searching()"
                matInput
                [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="display" [(ngModel)]="industriepartner">
                    <mat-option *ngFor="let i of filteredIndustriePartners" [value]="i">{{i.display}}</mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <button mat-raised-button color="primary" [disabled]="!search?.anbieterNr || adding" (click)="add()">
                Neukunde anlegen
            </button>
        </mat-card-content>
    </mat-card>
</div>